import { render, staticRenderFns } from "./carmaintenanceinformation.vue?vue&type=template&id=08512cc0&scoped=true"
import script from "./carmaintenanceinformation.vue?vue&type=script&lang=js"
export * from "./carmaintenanceinformation.vue?vue&type=script&lang=js"
import style0 from "./carmaintenanceinformation.vue?vue&type=style&index=0&id=08512cc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08512cc0",
  null
  
)

export default component.exports